import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import Teams from "../../api/team";
import NavbarS2 from "../../components/NavbarS2/NavbarS2";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Contact from "./contact";
import bg from "../../images/history-bg.png";

const TeamSinglePage = (props) => {
  return (
    <div
      className="team-pg-area section-padding pt-0"
      style={{ background: "#FAFBFE" }}
    >
      <div className="team-inner section-padding">
        <div className="container">
          <div
            className="team-info-wrap"
            style={{ padding: window.innerWidth >= 768 ? "" : "0 15px" }}
          >
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="team-info-img">
                  <img src={bg} alt="" />
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="team-info-text"
                  style={{ width: window.innerWidth >= 768 ? "1000px" : "" }}
                >
                  {/* <h2>{TeamSingles.title}</h2>
                                    <span>{TeamSingles.subtitle}</span> */}

                  <p
                    style={{
                      color: "#000",
                      fontWeight: "900",
                      fontSize: window.innerWidth >= 768 ? "32px" : "22px",
                      lineHeight: "180%",
                      marginBottom: "30px",
                    }}
                  >
                    고객 여러분, 안녕하십니까?
                  </p>

                  <p
                    style={{
                      color: "#000",
                      fontSize: window.innerWidth >= 768 ? "20px" : "16px",
                      lineHeight: "180%",
                      marginBottom: "30px",
                    }}
                  >
                    ㈜엠알메탈로는 2012년 설립 이래, 환경기술에 대한 확고한
                    신념과 철학을 바탕으로 폐수{" "}
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    재활용과 금속원료 추출 분야에서 전문기술과 노하우를
                    축적해왔으며, {window.innerWidth >= 1200 ? <br /> : " "}
                    항상 고객사와의 상생을 최우선으로 생각하며, 신뢰를 바탕으로
                    고객 가치를 높여 나가고
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    {/*  바탕으로 그동안에 R&D 기술부재로 버려지거나 사장되어 오던  { window.innerWidth >= 1200 ? <br /> : " " } */}
                    있습니다.
                  </p>
                  <p
                    style={{
                      color: "#000",
                      fontSize: window.innerWidth >= 768 ? "20px" : "16px",
                      lineHeight: "180%",
                      marginBottom: "30px",
                    }}
                  >
                    우리는 환경, 안전, 품질 관련 기본적인 인증 절차를 준수하고
                    있으며, 폐수처리 및 재활용{" "}
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    사업을 위한 모든 준비를 갖추고 있습니다.
                  </p>
                  <p
                    style={{
                      color: "#000",
                      fontSize: window.innerWidth >= 768 ? "20px" : "16px",
                      lineHeight: "180%",
                      marginBottom: "30px",
                    }}
                  >
                    특히 ESG경영이 강조되는 지금, 고객과의 긴밀한 상생과 협력이
                    이뤄져야 하는 기업환경 속에서
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    폐수재이용업, 유해화학물질 사용업, 폐기물종합재활용업등 관련
                    허가를 보유하고 있습니다.
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    이를 기반으로 국가적인 자원 및 에너지 낭비를 줄이고,
                    고부가가치 산업인 도시광산 Recycling을
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    선도적으로 주도하여, 끊임없는 연구개발을 통해 지속 가능한
                    Recycling 선두기업으로
                    {window.innerWidth >= 1200 ? <br /> : " "}
                    만들어 가겠습니다.
                  </p>
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "700",
                      fontSize: window.innerWidth >= 768 ? "20px" : "16px",
                      lineHeight: "180%",
                      marginTop: "30px",
                    }}
                  >
                    임직원 일동
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TeamSinglePage;
